import zod from "zod"
import { getStringSchema } from "./shared"

export const viewAllRequestSchema = zod
  .object({
    requestType: zod.string().nullable(),
    requestDestination: zod.array(
      zod
        .object({
          value: getStringSchema(),
          label: getStringSchema(),
        })
        .nullable(),
    ),
  })
  .partial()

export type ViewAllRequestModel = zod.infer<typeof viewAllRequestSchema>
